/* eslint semi:0 */
import { getIsNativeApp } from '../../utils/ua'
import { taboolaScriptConfig } from './taboolaScriptConfig'
import { getGtmScriptConfig } from './gtmScriptConfig'
import { getAmplitudeScriptConfig } from './amplitudeScriptConfig'
import { queryString } from '../../utils/window'
import { warn } from '../../application/console'
import { noop, makeSafeFn } from '../../utils/fn'
import { registerUtils } from '../../application/nm'
import facebookPixel from './facebookPixelScript'
import headerBidder from './headerBidderScriptConfig'
import { iterate as iterateObject } from '../../utils/object'
import { browsiScriptConfig as browsi } from './browsiScriptConfig'
import { getInfluencerId } from '../../utils/pageContext'

import {
  get as getFromPdo,
  getIsEmbededPost,
  getIsTopX,
  getIsSlideshow,
  getIsHybrid,
  getGTMIds,
  getGTMData,
} from '../../application/pageDataObject'
import { ready as onGoogleSearchActionsReady } from '../../organizedByType/actions/googleSearchActions'

const { trs_id: trafficSrcId } = queryString
const affiliateId = getInfluencerId()

const externalScriptsConfig = {
  facebookPixel,
  browsi,

  googleAnalytics: {
    src: 'https://www.google-analytics.com/analytics.js',
    beforeLoad() {
      window.GoogleAnalyticsObject = 'ga'
      const ga = (window.ga =
        window.ga ||
        function setGoogleAnalyticsQ() {
          ;(ga.q = ga.q || []).push(arguments)
        })
      ga.l = 1 * new Date()
      ga('create', getFromPdo('config.google_analytics.account_id'), 'auto')
      // for double-click: https://support.google.com/analytics/answer/3450482
      ga('require', 'displayfeatures')
    },
  },

  gtmAnalytics: getGtmScriptConfig(getGTMIds(), getGTMData()),

  amplitude: getAmplitudeScriptConfig(),

  comscore: {
    src: 'https://sb.scorecardresearch.com/beacon.js',
    beforeLoad() {
      window._comscore = window._comscore || []
      window._comscore.push({
        ...getFromPdo('config.comscore.account'),
      })
    },
  },
  agof: { src: 'https://script.ioam.de/iam.js' },

  facebook: {
    src: `https://connect.facebook.net/${getFromPdo('config.facebook.sdk_locale', 'en_US')}/sdk.js`,
    onload: makeSafeFn(function onFacebookSdkLoaded() {
      window.FB.init({
        appId: getFromPdo('config.facebook.app_id'),
        version: getFromPdo('config.facebook.api_version'),
        cookie: true,
        xfbml: true,
      })
    }),
  },

  twitter: { src: 'https://platform.twitter.com/widgets.js' },
  riddle: { src: 'https://www.riddle.com/files/js/embed.min.js' },

  googleSearch: {
    src: `https://www.google.com/cse/cse.js?cx=${getFromPdo('config.google_search.cx')}`,
    beforeLoad() {
      window.__gcse = { callback: onGoogleSearchActionsReady }
    },
  },

  zoomd: {
    src: `https://zdwidget3-bs.sphereup.com/zoomd/SearchUi/Script?clientId=${getZoomdConfig()}`,
    name: 'zoomd',
  },

  taboolaScriptConfig,
  headerBidder,

  dfp: {
    src: 'https://www.googletagservices.com/tag/js/gpt.js',
    beforeLoad() {
      const inAppConditions =
        getIsHybrid() && !getIsEmbededPost() && !affiliateId && !getIsTopX() && !getIsSlideshow()
      return getIsNativeApp() ? inAppConditions : true
    },
  },

  youtube: {
    src: 'https://www.youtube.com/iframe_api',
    name: 'youtubeAPI',
  },

  freshEightMX: {
    src: 'https://fresh8.co/391499/embed.js?view=Article',
    name: 'freshEightMX',
  },
  freshEightGB: {
    src: 'https://fresh8.co/874248/embed.js?view=article',
    name: 'freshEightGB',
  },

  arcadium: {
    src: 'https://inhabit-service.cdn.arkadiumhosted.com/Widget/v1/',
    name: 'arcadium',
  },
  playgorithm: {
    src:
      'https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-531&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6NTMxLCJ0b2tlbiI6IiQyeSQxMCR5d1wvM2pVWFgzeFhGdHJ6a3VyODlXT005ZEJiYlN2YVF3azB0d1wvVHI4WHpXRFl5NFBjUW5HIiwidGltZXN0YW1wIjoxNTQ2NTUxOTU1fQ==&origin=https://frontend.playgorithm.net&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-17&height=360px',
    name: 'playgorithm',
  },
  jwplayer: {
    src(playerId) {
      return `https://content.jwplatform.com/libraries/${playerId}.js`
    },
  },

  playbuzz: { src: 'https://cdn.playbuzz.com/widget/feed.js' },

  monti: {
    src() {
      return 'https://www.oo-syringe.com/prod/players/mplayer_wrapper_v3_latest.js'
    },
  },

  montiSEOtest: {
    src() {
      return 'https://www.oo-syringe.com/qa/players/mplayer_wrapper.3.2.9.js'
    },
  },

  newscorp: {
    src: '//www.ballball.com/static/js/enhanced_player/1.1/enhanced_player_host.js',
  },

  // perimeterX: {
  //   src: 'https://client.a.pxi.pub/PXszbKVa5M/main.min.js',
  //   beforeLoad() {
  //     Object.assign(window, {
  //       _pxAppId: 'PXszbKVa5M',
  //       _pxParam1: affiliateId,
  //       _pxParam3: trafficSrcId,
  //       _pxPubHost: 'collector.a',
  //     })
  //   },
  // },

  jQuery: { src: 'https://code.jquery.com/jquery-2.1.4.min.js' },
}

export const SCRIPT_LOADER_CONF_DEFAULTS = {
  defer: true,
  onload: noop,
  beforeLoad() {
    return true
  },
}

function getZoomdConfig() {
  return typeof getFromPdo('config.zoomd_search') !== 'undefined'
    ? getFromPdo('config.zoomd_search')
    : getFromPdo('zoomd_search')
}

function addNamePropertyToScriptConf(scriptConf, scriptName) {
  const scriptConfName = scriptConf.name || scriptName
  const { src } = scriptConf
  if (!src) {
    const falsySrcErrorMessage = `Falsy src ('${src}') in scriptConf name '${scriptConfName}'!`
    warn(falsySrcErrorMessage, { scriptConf, scriptConfName })
  }
  scriptConf.name = scriptConfName
}

Object.assign(iterateObject(externalScriptsConfig, addNamePropertyToScriptConf), {
  defaults: SCRIPT_LOADER_CONF_DEFAULTS,
})

registerUtils({ externalScriptsConfig })

export { externalScriptsConfig }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/externalScripts.js